import React, { useState } from "react";
import { FaExclamationTriangle, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "./delete_modal.css";

const ConfirmModal = ({
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  type = "danger",
  requirePassword = true,
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (requirePassword && !password.trim()) {
      setError("Please enter your current password to confirm deletion.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await onConfirm(password);
    } catch (err) {
      setError(err.message || "Failed to complete action. Incorrect password or permission denied.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <div className="popup_overlay_delete" onClick={onCancel}>
      <div
        className="popup_content_delete"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="confirm_header">
          <div className="confirm_icon_wrapper">
            <FaExclamationTriangle className="confirm_icon" />
          </div>
          <h3>{title}</h3>
        </div>
        <hr className="confirm-divider" />

        {/* Message */}
        <p className="confirm_message">{message}</p>

        {/* Security Password Check */}
        {requirePassword && (
          <form
            className="confirm_password_block"
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              handleConfirm();
            }}
          >
            {/*
              Decoy fields: tricks Chrome/Edge's autofill heuristic into
              thinking this is NOT the site's login form, so it stops
              offering to fill in the saved email/password below.
            */}
            <input
              type="text"
              name="fakeusernameremembered"
              autoComplete="username"
              style={{ display: "none" }}
              tabIndex={-1}
              aria-hidden="true"
            />
            <input
              type="password"
              name="fakepasswordremembered"
              autoComplete="new-password"
              style={{ display: "none" }}
              tabIndex={-1}
              aria-hidden="true"
            />

            <label className="confirm_password_label">
              <FaLock className="lock_icon" /> Security Verification Required: Enter Current Password
            </label>

            <div className="confirm_password_wrapper">
              <input
                className={`confirm_password_input ${error ? "has_error" : ""}`}
                type={showPassword ? "text" : "password"}
                placeholder="Your current login password"
                value={password}
                autoFocus
                autoComplete="new-password"
                name="confirm_delete_password_field"
                data-lpignore="true"
                data-1p-ignore="true"
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError("");
                }}
              />
              <button
                type="button"
                className="confirm_eye_btn"
                onClick={() => setShowPassword((prev) => !prev)}
                tabIndex={-1}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            {error && <span className="confirm_password_error">{error}</span>}
          </form>
        )}

        {/* Actions */}
        <div className="confirm_actions">
          <button className="secondary_btn" onClick={onCancel} disabled={loading}>
            {cancelText}
          </button>

          <button
            className={`confirm_btn ${type}`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Confirming…" : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;